import { render, staticRenderFns } from "./hasBankAccount.vue?vue&type=template&id=133dbbf6"
import script from "./hasBankAccount.vue?vue&type=script&lang=js"
export * from "./hasBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports